var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDomainregistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.605 9.34c40.06 20.5-.88 72.35-41.62 84.31-40.74 11.96-66.04.17-61.45-45.63 4.59-45.8 63.01-59.17 103.07-38.68z",
    fill: "#629FE2",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.242 59.408l61.262 17.197a1.288 1.288 0 001.64-.882l11.357-42.353a1.341 1.341 0 00-.989-1.606L57.26 14.524a1.306 1.306 0 00-1.65.881L44.254 57.802a1.35 1.35 0 00.988 1.606z",
    fill: "#1559D7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E53232",
    fillRule: "nonzero",
    d: "M59.015 15.017l-3.855 2.038-.671 2.524 7.182-3.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B4AAF",
    fillRule: "nonzero",
    d: "M66.339 17.073l-13.032 6.909-.671 2.515 16.368-8.674z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E53232",
    fillRule: "nonzero",
    d: "M73.662 19.129l-22.208 11.78-.671 2.514L76.327 19.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B4AAF",
    fillRule: "nonzero",
    d: "M80.986 21.185l-31.385 16.65-.67 2.515 34.72-18.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E53232",
    fillRule: "nonzero",
    d: "M88.31 23.24L47.748 44.762l-.67 2.515 43.896-23.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B4AAF",
    fillRule: "nonzero",
    d: "M95.633 25.297l-49.738 26.39-.67 2.515 53.073-28.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E53232",
    fillRule: "nonzero",
    d: "M102.957 27.352L44.042 58.605l-.115.433 2.206.626 59.488-31.562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B4AAF",
    fillRule: "nonzero",
    d: "M110.289 29.408L50.792 60.97l2.665.75 59.488-31.562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E53232",
    fillRule: "nonzero",
    d: "M117.612 31.464L58.124 63.026l2.656.75 58.941-31.27.106-.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B6FD5",
    fillRule: "nonzero",
    opacity: 0.28,
    d: "M65.448 65.082l2.656.75 49.764-26.4.67-2.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E53232",
    fillRule: "nonzero",
    d: "M72.771 67.138l2.665.75 40.58-21.53.67-2.514z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B6FD5",
    fillRule: "nonzero",
    opacity: 0.28,
    d: "M80.095 69.194l2.665.75 31.402-16.66.671-2.514z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E53232",
    fillRule: "nonzero",
    d: "M87.418 71.25l2.665.75L112.31 60.21l.67-2.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B4AAF",
    fillRule: "nonzero",
    d: "M94.742 73.305l2.665.75 13.05-6.917.67-2.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E53232",
    fillRule: "nonzero",
    d: "M102.065 75.361l2.665.75 3.874-2.056.67-2.514z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A7CDD",
    fillRule: "nonzero",
    d: "M106.45 74.267L46.46 57.423l10.852-40.562 59.992 16.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B4AAF",
    fillRule: "nonzero",
    opacity: 0.79,
    d: "M106.45 74.267L46.46 57.423l10.852-40.562 59.992 16.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.936 14.152l63.891 17.939-12.009 44.885-63.89-17.938z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.936 14.152l63.891 17.939-12.009 44.885-63.89-17.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D3FD5",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M106.45 74.267L46.46 57.423l10.852-40.562 59.992 16.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M105.357 72.988l-58.66-16.465 10.615-39.662 59.992 16.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A7CDD",
    fillRule: "nonzero",
    d: "M105.357 72.988l-58.66-16.465 10.615-39.662 59.992 16.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M63.4 43.279l2.648.776-.777 2.647-2.647-.767zM71.236 36.847l2.568.74-.362 1.236a6.785 6.785 0 01-.256.724 4.332 4.332 0 014.412-1.121c2.373.688 3.362 2.32 2.54 5.153l-1.923 6.891-2.647-.768 1.836-6.335c.379-1.306.3-2.285-1.068-2.647a3.062 3.062 0 00-3.53 1.341 4.624 4.624 0 00-.6 1.377l-1.402 4.88-2.647-.777 3.079-10.694zM88.874 41.69c3.088.883 4.103 3.618 3.283 6.45-.097.318-.362 1.015-.362 1.015l-7.403-2.144a3.168 3.168 0 002.4 3.76 5.488 5.488 0 003.423-.274l.477 2.205c-1.5.65-3.18.75-4.747.283a5.718 5.718 0 01-4.138-7.262 5.506 5.506 0 017.067-4.032zm.812 4.915a2.144 2.144 0 00-1.474-2.832 2.647 2.647 0 00-3.211 1.474l4.685 1.358zM95.554 46.376l-1.386-.397.618-2.127 1.447.424.882-3.088 2.647.759-.882 3.088 2.444.706-.617 2.117-2.436-.706-1.209 4.156a1.976 1.976 0 001.536 2.647c.16.05.326.083.494.097l-.67 2.33a4.491 4.491 0 01-.839-.177c-1.491-.432-4.323-1.764-3.282-5.294l1.253-4.535z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.06 82.782l61.111-16.95a1.403 1.403 0 001.033-1.765L64.027 22.13a1.465 1.465 0 00-1.765-.927L1.107 38.135a1.394 1.394 0 00-1.033 1.712l12.177 41.982a1.447 1.447 0 001.809.953z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01 38.161a1.306 1.306 0 00-.971 1.589L12.277 81.9c.228.699.971 1.09 1.677.882l61.314-16.977c.69-.17 1.12-.858.97-1.553L64.002 22.041a1.35 1.35 0 00-1.677-.883",
    fill: "#629FE2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2470DB",
    fillRule: "nonzero",
    d: "M2.765 37.676l-2.24 3.741.723 2.497 4.182-6.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F48",
    fillRule: "nonzero",
    d: "M10.098 35.647L2.528 48.3l.723 2.505 9.511-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2470DB",
    fillRule: "nonzero",
    d: "M17.43 33.608L4.521 55.182l.724 2.506 14.85-24.812z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F48",
    fillRule: "nonzero",
    d: "M24.762 31.579L6.515 62.073l.733 2.497 20.18-33.723z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2470DB",
    fillRule: "nonzero",
    d: "M32.095 29.55L8.518 68.955l.724 2.497L34.76 28.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F48",
    fillRule: "nonzero",
    d: "M39.427 27.52L10.512 75.838l.733 2.506 30.838-51.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2470DB",
    fillRule: "nonzero",
    d: "M46.75 25.49L12.516 82.72l.124.432 2.206-.608 34.57-57.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F48",
    fillRule: "nonzero",
    d: "M54.083 23.461l-34.57 57.786 2.664-.742 34.57-57.785z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2470DB",
    fillRule: "nonzero",
    d: "M61.415 21.423l-34.57 57.794 2.665-.741 34.252-57.247-.123-.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F48",
    fillRule: "nonzero",
    d: "M34.177 77.188l2.665-.741L65.757 28.11l-.724-2.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2470DB",
    fillRule: "nonzero",
    d: "M41.51 75.158l2.664-.74L67.76 34.993l-.733-2.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F48",
    fillRule: "nonzero",
    d: "M48.842 73.129l2.665-.741 18.247-30.503-.724-2.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2470DB",
    fillRule: "nonzero",
    d: "M56.174 71.09l2.665-.732 12.918-21.59-.733-2.507z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F48",
    fillRule: "nonzero",
    d: "M63.507 69.061l2.664-.74 7.58-12.671-.724-2.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2470DB",
    fillRule: "nonzero",
    d: "M70.839 67.032l2.665-.741 2.25-3.76-.733-2.496z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M74.015 63.829L13.962 80.46l-11.7-40.323 60.053-16.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCFCF",
    fillRule: "nonzero",
    d: "M74.015 63.829L13.962 80.46l-11.7-40.323 60.053-16.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEBEB",
    fillRule: "nonzero",
    d: "M72.418 63.3L13.707 79.56 2.262 40.138l58.712-16.262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F48",
    fillRule: "nonzero",
    d: "M12.621 61.605l2.86-.758.767 2.858-2.86.768zM21.55 49.711a6.053 6.053 0 014.871.53l-.74 2.294a4.659 4.659 0 00-3.327-.433 3.53 3.53 0 00-2.542 4.492 3.626 3.626 0 004.553 2.647 5.488 5.488 0 002.983-2.365l1.65 1.765a6.768 6.768 0 01-4.236 3.132 6.23 6.23 0 11-3.211-12.026v-.036zM33.868 46.411a6.238 6.238 0 113.239 12.027c-3.53.935-6.989-.786-7.942-4.324a6.247 6.247 0 014.703-7.703zm2.594 9.591a3.715 3.715 0 10-4.411-2.647 3.53 3.53 0 004.411 2.647zM42.568 44.373l2.744-.732.362 1.323c.07.265.126.533.168.803a4.474 4.474 0 013.097-3.388 3.274 3.274 0 013.988 1.465 4.65 4.65 0 013.38-3.415c2.382-.644 4.12.344 4.932 3.362l1.976 7.367-2.858.742-1.836-6.848c-.353-1.305-.882-2.232-2.197-1.879-1.314.353-2.117 1.827-2.064 3.362.025.514.111 1.023.255 1.517l1.36 5.048-2.868.767-1.827-6.82c-.318-1.245-.82-2.206-2.17-1.889-1.492.406-2.145 1.836-2.11 3.397a6.07 6.07 0 00.257 1.5l1.35 5.039-2.86.767-3.079-11.488z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainregistration);
export default __webpack_public_path__ + "static/media/domainregistration.098222bc7252bfef5b1a97c26e2bdafb.svg";
export { ForwardRef as ReactComponent };